
/**
 * Extrai o nome do repositório a partir da URL
 * Exemplo: "https://github.com/luizvalenterj/mozarch-site" -> "luizvalenterj/mozarch-site"
 */
export function extractRepoNameFromUrl(url: string): string {
  if (!url || typeof url !== 'string') {
    return '';
  }

  try {
    // Remove protocolo e limpa a URL
    let cleanUrl = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
    
    // Divide por "/" e pega as duas últimas partes
    const parts = cleanUrl.split('/');
    
    if (parts.length >= 2) {
      const repoName = parts[parts.length - 1];
      const ownerName = parts[parts.length - 2];
      return `${ownerName}/${repoName}`;
    }
    
    return '';
  } catch (error) {
    console.warn('Erro ao extrair nome do repositório da URL:', error);
    return '';
  }
}
